import {
  ApplicationRef,
  ComponentFactory,
  ComponentFactoryResolver,
  ComponentRef,
  EmbeddedViewRef,
  Injectable,
  Injector,
  Type
} from '@angular/core';
import { DialogActionComponent } from '../custom-controls/dialogs/dialog-action.component';
import { DialogComponent } from '../custom-controls/dialogs/dialog.component';
import { IFrameDialogComponent } from '../custom-controls/dialogs/i-frame-dialog.component';
import { SessionService } from './session/session.service';

@Injectable({
  providedIn: 'root'
})
export class DialogService {
  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private appRef: ApplicationRef,
    private injector: Injector,
    private session: SessionService
  ) {}

  public isShowing = false;
  public isBindding = false;

  public showMessageBox(content: string, actions: string[] = ['Ok'], title: string = ' '): void {
    if (this.isShowing) {
      return;
    }
    let buttons: DialogActionComponent[] = [];
    if (actions) {
      buttons = actions.map((action: string) => {
        const button: DialogActionComponent = new DialogActionComponent(this.session);
        button.type = action;
        return button;
      });
    }

    const hostDialogRef: ComponentRef<DialogComponent> = this.appendDialogComponentToBody(DialogComponent);
    hostDialogRef.instance.title = title;
    hostDialogRef.instance.leadingText = content;
    hostDialogRef.instance.actions = buttons;
    hostDialogRef.instance.visible = true;
    this.isShowing = true;
    hostDialogRef.instance.visibleChange.subscribe((visible: boolean) => {
      if (!visible) {
        buttons.forEach((b: DialogActionComponent) => b.ngOnDestroy());
        this.removeDialogComponentFromBody(hostDialogRef);
        this.isShowing = false;
      }
    });
  }

  public showIFrameDialog(content: string, title: string = ' ', isSelfService?: boolean): void {
    if (this.isShowing) {
      return;
    }
    const hostDialogRef: ComponentRef<IFrameDialogComponent> = this.appendDialogComponentToBody(IFrameDialogComponent);
    hostDialogRef.instance.isSelfService = isSelfService;
    hostDialogRef.instance.title = title;
    hostDialogRef.instance.visible = true;
    hostDialogRef.instance.iframeContent = content;
    this.isShowing = true;
    hostDialogRef.instance.visibleChange.subscribe((visible: boolean) => {
      if (!visible) {
        this.removeDialogComponentFromBody(hostDialogRef);
        this.isShowing = false;
      }
    });
  }

  private appendDialogComponentToBody<T>(component: Type<T>): ComponentRef<T> {
    const componentFactory: ComponentFactory<T> = this.componentFactoryResolver.resolveComponentFactory(component);
    const componentRef: ComponentRef<T> = componentFactory.create(this.injector);
    this.appRef.attachView(componentRef.hostView);
    const domElem: HTMLElement = (componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement;
    document.body.appendChild(domElem);
    return componentRef;
  }

  private removeDialogComponentFromBody(componentRef: ComponentRef<any>): void {
    this.appRef.detachView(componentRef.hostView);
    componentRef.changeDetectorRef.detectChanges();
    componentRef.destroy();
  }
}
